import { motion } from "framer-motion";

export default function About() {
  return (
    <section
      id="sobre"
      data-testid="about-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream"
    >
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.4 }}
          className="grid grid-cols-1 md:grid-cols-12 gap-12"
        >
          <div className="md:col-span-3">
            <span className="section-num" data-testid="about-eyebrow">01 · O livro</span>
          </div>

          <div className="md:col-span-9">
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-ink mb-10 leading-[1.02]">
              Isto não é mais
              <br />
              um livro de <span className="brush-underline">auto-ajuda.</span>
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl text-ink-soft">
              <p className="text-lg leading-relaxed">
                É um <strong className="text-ink font-medium">workbook</strong>. Um espaço silencioso
                para te sentares contigo, com uma caneta na mão e a coragem
                de olhares para o que tens andado a adiar.
              </p>
              <p className="text-lg leading-relaxed">
                Dez capítulos, dez exercícios. Foi escrito para quem está cansada
                — não do trabalho nem das pessoas — mas de uma versão de si que
                já não reconhece.
              </p>
            </div>

            <motion.blockquote
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.08 }}
              className="mt-14 max-w-2xl border-l-2 border-orange pl-6"
            >
              <p className="font-serif-display text-3xl md:text-4xl text-ink leading-snug">
                "Não é um drama. <span className="text-orange">É lucidez.</span>"
              </p>
            </motion.blockquote>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
